import { AddMemberForm as SharedAddMemberForm, type NewMember } from '@monorepo/shared-lib';
import { UpgradeMessage } from 'containers/UpgradeMessage';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpgradeMessageSource } from 'store/api/enums';
import { turnModalOff, turnModalOn } from 'store/app/actions';
import { WindowType } from 'store/app/enums';
import { getAuthUser, getAuthUserLicence } from 'store/auth/selectors';
import { getCurrentSubscription } from 'store/billing/selectors';
import { isSmallOrMediumPlanLocked } from 'utils/subscriptionPlanGate';

interface AddMemberFormProps {
  saveNewMember: (newMember: NewMember) => void;
}

export const AddMemberForm: React.FC<AddMemberFormProps> = ({ saveNewMember }) => {
  const dispatch = useDispatch();
  const currentSubscription = useSelector(getCurrentSubscription);
  const currentUser = useSelector(getAuthUser);
  const userLicence = useSelector(getAuthUserLicence);
  const isClientDisabled = isSmallOrMediumPlanLocked(
    currentSubscription,
    userLicence
  );

  return (
    <SharedAddMemberForm
      saveNewMember={saveNewMember}
      isClientDisabled={isClientDisabled}
      onClientLockedClick={() =>
        dispatch(
          turnModalOn({
            title: '',
            type: WindowType.WARNING,
            component: (
              <UpgradeMessage
                source={UpgradeMessageSource.CLIENT_FLOW}
                onClose={() => dispatch(turnModalOff())}
                userAccountType={currentUser?.accountType}
              />
            ),
          })
        )
      }
    />
  );
};
